import * as React from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress } from "@mui/material";

export const RHFAutocomplete = (
  props
) => {
  const { control, options, name, defaultValue, disabled, loading, error, helperText } = props;
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: "this field is requried"
      }}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ref } = field;
        return (
          <>
            <Autocomplete
              disabled={disabled}
              value={
                value
                  ? options.find((option) => {
                    return value === option.id;
                  }) ?? null
                  : null
              }
              defaultValue={defaultValue}
              getOptionLabel={(option) => {
                return option.label;
              }}
              getOptionKey={(option) => {
                return option.id;
              }}
              onChange={(event, newValue) => {
                const resolvedId = newValue ? newValue.id : null;
                onChange(resolvedId);
                props.onChange?.(resolvedId);
              }}
              id="controllable-states-demo"
              options={options}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={props.placeholder}
                  inputRef={ref}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                  error={error}
                  helperText={helperText}
                />
              )}
              style={props.style}
            />
          </>
        );
      }}
    />
  );
};
